import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';

interface OfficeEmailRefs {
  emailTitleRef: RefObject<HTMLElement | null>;
  emailAddressRef: RefObject<HTMLElement | null>;
}

export function setupEmailEnterTimeline(
  timeline: gsap.core.Timeline,
  { emailTitleRef, emailAddressRef }: OfficeEmailRefs,
): void {
  const emailTitleController = findTransitionController(emailTitleRef);
  const emailAddressController = findTransitionController(emailAddressRef);

  if (emailTitleController) {
    timeline.add(emailTitleController.getTimeline('in') as gsap.core.Timeline, 0);
  }
  if (emailAddressController) {
    timeline.add(emailAddressController.getTimeline('in') as gsap.core.Timeline, 0.05);
  }
}

export function setupEmailLeaveTimeline(
  timeline: gsap.core.Timeline,
  { emailTitleRef, emailAddressRef }: OfficeEmailRefs,
): void {
  const emailTitleController = findTransitionController(emailTitleRef);
  const emailAddressController = findTransitionController(emailAddressRef);

  if (emailTitleController) {
    timeline.add(emailTitleController.getTimeline('out') as gsap.core.Timeline, 0);
  }
  if (emailAddressController) {
    timeline.add(emailAddressController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}
